import ConfirmationProvider from "shared/components/ConfirmationProvider";
import { useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Material Dashboard 2 React example components
import Sidenav from "app/navigation/Sidenav";
import Configurator from "app/layout/Configurator";
import ModuleGuideLibrary from "app/help/ModuleGuideLibrary";

// Material Dashboard 2 React routes
import routes from "app/routes";

// Material Dashboard 2 React contexts
import { useMaterialUIController } from "app/providers";

// Images
import brandWhite from "assets/images/logoBlanco.png";
import brandDark from "assets/images/logo horinzontal.png";
import ProtectedRoute from "app/routing/ProtectedRoute";
import Unauthorized from "app/pages/MDUnauthorized";
import NotFound from "app/pages/MDNotFound";

export default function App() {
  const [controller] = useMaterialUIController();
  const { direction, layout, sidenavColor, transparentSidenav, whiteSidenav, darkMode } =
    controller;
  const { pathname } = useLocation();

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) => {
    return allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        if (route.public) {
          return <Route exact path={route.route} element={route.component} key={route.key} />;
        } else {
          return (
            <Route
              key={route.key}
              path={route.route}
              element={
                <ProtectedRoute requiredPermission={route.permissionKey}>
                  {route.component}
                </ProtectedRoute>
              }
            />
          );
        }
      }

      return null;
    });
  };

  return direction === "rtl" ? (
    <ConfirmationProvider cancelKey={pathname}>
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName="Goper"
            routes={routes}
          />
          <Configurator />
          <ModuleGuideLibrary floating />
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(routes)}
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ConfirmationProvider>
  ) : (
    <ConfirmationProvider cancelKey={pathname}>
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
            brandName=""
            routes={routes}
          />
          <Configurator />
          <ModuleGuideLibrary floating />
        </>
      )}
      {layout === "vr" && <Configurator />}
      <Routes>
        {getRoutes(routes)}
        <Route path="/" element={<Navigate to="/authentication/sign-in" />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </ConfirmationProvider>
  );
}
